import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Error } from '../error';
import { Button, Input, PillButtons } from '../input';
import { Loading } from '../loading';
import { useGlobal } from '../../state';
import { AgentCode } from './AgentCode';
import { SummaryTitle } from '../title';

export const AgentRun = ({ agentId }) => {
  const navigate = useNavigate();
  const { fox, sdk } = useGlobal();
  const [agent, setAgent] = useState();
  const [values, setValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [tab, setTab] = useState('run');

  const fields = agent?.plan?.fields || {};

  useEffect(() => {
    if (!sdk || !agentId) {
      return;
    }

    let cancelled = false;
    let retry;
    const load = async () => {
      try {
        const out = await sdk.call('GET', `/api/agent/${agentId}`);
        if (cancelled) {
          return;
        }
        setAgent(out);
        const initial = {};
        for (const name of Object.keys(out.plan.fields)) {
          initial[name] = out.plan.fields[name].default;
        }
        console.log('Set initial values:', initial);

        setValues(initial);
      } catch {
        if (!cancelled) {
          retry = setTimeout(load, 1000);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
      clearTimeout(retry);
    };
  }, [sdk, agentId]);

  const handleRunAgent = async (event) => {
    event.preventDefault();
    if (!fox || loading) {
      return;
    }

    setError();
    setLoading(true);
    try {
      const out = await fox.call('POST', `/api/agent/${agentId}/run`, {
        ...values,
        detach: true,
      });
      navigate(`/agents/${out.jobId}`);
    } catch (e) {
      setError(e.message || 'Could not run agent');
      setLoading(false);
    }
  };

  if (!agent) {
    return <Loading>Preparing agent...</Loading>;
  }

  return (
    <div style={{ maxWidth: 680 }}>
      <SummaryTitle summaryKey={agentId && `agentId:2:${agentId}`} object={agent?.plan} fallback="Run Agent" />
      <h2>Run agent</h2>
      <p style={{ color: '#666' }}>{agent.plan?.params?.master}</p>

      {/*
      <pre>{JSON.stringify(fields, null, 2)}</pre>
        */}
      <PillButtons
        choices={[
          ['run', 'Run'],
          ['code', 'Code'],
        ]}
        value={tab}
        onChange={setTab}
      />

      {tab == 'code' && (
        <div style={{ marginTop: 16 }}>
          <AgentCode agentId={agentId} params={values} />
        </div>
      )}

      {tab == 'run' && (
        <form onSubmit={handleRunAgent} style={{ display: 'flex', flexDirection: 'column', gap: 16, marginTop: 16 }}>
          {Object.entries(fields).map(([name, field]) => (
            <div key={name}>
              <Input
                label={name}
                help={field.description}
                value={values[field.name]}
                placeholder={field.examples[0]}
                onChange={(event) => setValues({ ...values, [name]: event.target.value })}
              />
              {!!field.examples.length && (
                <div style={{ color: '#777', fontSize: 12, marginTop: 5 }}>Examples: {field.examples.join(', ')}</div>
              )}
            </div>
          ))}

          {!Object.keys(fields).length && <div style={{ color: '#666' }}>This agent has no run-time parameters.</div>}
          <Error message={error} />
          <Button loading={loading} disabled={loading} style={{ alignSelf: 'flex-start' }}>
            Run agent
          </Button>
        </form>
      )}
    </div>
  );
};
